import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import Cookies from "js-cookie";
import { useCallback } from "react";

export function useAudioAnalytics() {
  const sendDataToGTM = useGTMDispatch();

  const analyticsCall = useCallback(
    (
      event: string,
      eventLabel: string,
      audioId: string,
      audioListenedTime: number,
      audioDuration: number,
      audioListenedpercentage: number,
      audioSpeed: number,
      isAutoPlay?: "yes" | undefined,
    ) => {
      // Track number of stories played using a cookie
      if (event === "audio_start") {
        const currentCount = parseInt(
          Cookies.get("tts_played_count") || "0",
          10,
        );
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59, 999);
        Cookies.set("tts_played_count", (currentCount + 1).toString(), {
          expires: endOfDay,
        });
      }

      sendDataToGTM({
        event,
        ...(eventLabel && { audio_title: eventLabel }),
        ...(audioId && { audio_id: audioId }),
        ...(audioId && { audio_current_time: audioListenedTime }),
        ...(audioDuration && { audio_duration: audioDuration }),
        ...(audioId && {
          audio_percent: audioListenedpercentage,
        }),
        ...(audioSpeed && { audio_speed: audioSpeed }),
        ...(isAutoPlay && { audio_auto_played: isAutoPlay }),
        audio_source: event === "audio_start" ? "beyondwords" : "",
      });
    },
    [sendDataToGTM],
  );

  return analyticsCall;
}
